<template>
    <Multiselect
        v-model="value"
        :placeholder="placeholder"
        :searchable="true"
        :filterResults="false"
        :delay="0"
        :minChars="minChars"
        :resolveOnLoad="true"
        :noOptionsText="noOptionsText"
        :options="async function(query){ return await fetchData(query) }"
        @select="handleSelectedOption"
        ref="multiselect"
    >
        <template v-slot:singlelabel="{ value }">
            <div class="multiselect-multiple-label">
                {{ getZipFromLabel(value.label) }}
            </div>
        </template>
    </Multiselect>

    <input type="hidden" :name="name" :id="id" :value="inputVal">
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'

import axios from 'axios'
import emitter from '../../utils/emitter'

import Multiselect from '@vueform/multiselect'

export default {

    props: [
        'placeholder',
        'noOptionsText',
        'name',
        'id',
        'type',
        'zipId',
        'label'
    ],

    components: {
        Multiselect
    },

    setup(props) {

        const state = reactive({
            value: null,
            minChars: 2,
            multiselect: null,
            url: '/api/psc',
            inputVal: props.zipId
        })

        onMounted ( () => {
            if ( props.zipId.length > 0 ) state.value = props.zipId
        })

        async function fetchData(query) {

            if ( !query ) query = props.label

            const response = await axios.post(state.url, { s: query })

            const data = await response.data

            if ( query.length ) {
                return data.data.map( (item) => {
                    return { value: item.id, label:`${item.city}, ${item.zip}` }
                })
            }
        }

        function handleSelectedOption(value, option) {
            state.inputVal = value

            emitter.emit('onZipSelected', {
                city: getCityFromLabel(option.label),
                type: props.type
            })
        }

        function getCityFromLabel(text) {
            return text.slice(0, text.lastIndexOf(','))
        }

        function getZipFromLabel(text) {
            return text.substring(text.lastIndexOf(',')).replace(',', '')
        }

        return {
            ...toRefs(state),
            fetchData,
            handleSelectedOption,
            getCityFromLabel,
            getZipFromLabel
        }
    }
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
